import { NOT_SELECTED_ERROR } from '../../constants'

const validate = ({ activeVehicleId }, { isTrailer }) => {
  const errors = {}

  if (!(activeVehicleId || isTrailer)) {
    errors.activeVehicleId = NOT_SELECTED_ERROR
    errors._error = NOT_SELECTED_ERROR
  }

  return errors
}

export default validate
